const stateAnimationVisible = 'state-h-animation--visible';
const disableSelectors: string[] = ['.o-accordion', '.state-h-animation--disabled'];
const controllers: any[] = Array();
const animationDuration: number = 125;

/**
 * This function adds the standard component animation for the provided items
 *
 * Usage in TS:
 *
 * import addComponentAnimation from '@swisslife/shared-ui/src/utils/animations/js/animations';
 *
 * private controllers: any[] = Array();
 *
 * public async sync() {
 *      // please note: the item class should be the single block item you want to animate
 *  	this.controllers = await addComponentAnimation(this.$ctx, '.js-x-pattern__item-class', );
 * }
 *
 * public stop() {
 *  	for (const controller of this.controllers) {
 *  		controller.destroy(true);
 * 		}
 * 	}
 *
 * 	Usage in SCSS:
 *
 * 	@import '~@swisslife/shared-ui/src/utils/animations/css/animations';
 *
 * 	.m-your-element__to-animate {
 * 	    @include component-animation();
 * 	}
 *
 * Please note:
 * If you need a delay between single items of your component within the same row to get a stairs effect,
 * you need to add something like this (this example shows the needed styles for 2 items per row):
 *
 * @media #{$mq-medium-up} {
 * 	    &.state-h-animation--visible {
 * 		    &:nth-child(even) {
 * 			    transition-delay: 0.2s;
 * 			}
 * 	    }
 * }
 *
 * Debugging:
 * To debug, uncomment the function .addIndicators() to get visual hint's on the screen where the animation triggers are
 *
 */

export default async function addComponentAnimation($ctx: JQuery, itemSelector: string = '') {
	let $items = $ctx;

	// check if an item selector was provided
	if (itemSelector !== '') {
		$items = $(itemSelector, $ctx);
	}

	// check if component is within one of disabled selectors and return
	if (disableSelectors.length > 0) {
		for (const disableSelector of disableSelectors) {
			if ($ctx.closest(disableSelector).length > 0) {
				return controllers;
			}
		}
	}

	const {
		ScrollMagic,
	} = (await import(/* webpackChunkName: "dynamic-imports/animation-libs" */ './animation-libs')) as any;

	$.each($items, (index, item) => {
		const $item = $(item);

		const scene = new ScrollMagic.Scene({
			triggerElement: item,
			triggerHook: 'onEnter',
			offset: -animationDuration,
		}).on('enter leave', () => {
			$item.addClass(stateAnimationVisible);
		});
		// .addIndicators(); // add visual indicators to your page, to be able to see exactly when a scene is triggered;

		const scrollMagicController = new ScrollMagic.Controller();
		scrollMagicController.addScene(scene);
		controllers.push(scrollMagicController);
	});

	return controllers;
}

export { stateAnimationVisible };
